export interface BreadAnalysis {
  id: string;
  sessionId?: string;
  userId: string;
  createdAt: Date;
  imageUrl?: string;
  thumbnailUrl?: string;
  comments: string;

  // Bread characteristics (rated 0-100)
  ratings: {
    crumbStructure: number;
    ovenSpring: number;
    crust: number;
    crumbTexture: number;
  };

  // Baking parameters
  parameters: {
    fermentationType: 'direct' | 'cold-bulk' | 'slow-room' | 'cold-retard';
    fermentationDuration: number; // in hours
    bakingMethod: 'dutch-oven' | 'direct' | 'wood-fired';
    temperature: number; // 200-300°C
    weight: number; // 0-3kg
    bakingDuration: number; // 20-120 minutes
    hydration: number; // 50-100%
  };

  // Generated feedback
  feedback: {
    mainIssue: string;
    methodology: string;
    improvements: string[];
  };
}

export interface AnalysisRating {
  name: string;
  value: number;
  label: string;
  description: string;
}

export const ANALYSIS_RATINGS: AnalysisRating[] = [
  {
    name: 'crumbStructure',
    value: 50,
    label: 'Crumb Structure',
    description: 'How open and well-developed is the crumb?'
  },
  {
    name: 'ovenSpring',
    value: 50,
    label: 'Rise & Scoring',
    description: 'How well did the bread rise and expand during baking?'
  },
  {
    name: 'crust',
    value: 50,
    label: 'Crust Quality',
    description: 'Is the crust too thick, too thin, or just right?'
  },
  {
    name: 'crumbTexture',
    value: 50,
    label: 'Crumb Texture',
    description: 'Is the crumb gummy, dry, or perfectly moist?'
  }
];